import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link } from '@mui/material';
import { BrandMark } from '../../brand/BrandMark';

const Logo = forwardRef(({ disabledLink = false, sx, to, ...other }, ref) => {
  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        height: 40,
        width: 140,
        display: 'inline-flex',
        alignItems: 'center',
        color: 'text.primary',
        ...sx,
      }}
      {...other}
    >
      <BrandMark variant="wordmark" />
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} to={to || '/'} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
  to: PropTypes.string,
};

export default Logo;
